import { defineComponent } from 'vue';
import KvStaticImg from '@/components/angielacoquette/kv/static-img.vue';
import AngielacoquetteContents from '~/components/angielacoquette/contents/contents.vue';
import config from '@/configs';
export default defineComponent({
    name: 'PAngielacoquette',
    components: { KvStaticImg: KvStaticImg, AngielacoquetteContents: AngielacoquetteContents },
    head: function () {
        var title = '関内いいとこどり 異日常さんぽ♪ アンジー・ラ・コケット☆麗しのアンジー';
        var description = 'おしゃれでツンデレな白猫アンジーが秋の関内の見どころをご案内！街にある宝箱を探しながら、ちょっぴり違った異日常の関内をお散歩しましょ。';
        var meta = this.$helper.setMetaTitleAndDescription(title, description);
        var ogImage = config.url.prod + "/angee_ogp.jpg";
        meta.push(this.$helper.metaProperty('og:image', ogImage), this.$helper.meta('twitter:image', ogImage), this.$helper.metaProperty('og:url', config.url.prod + '/angielacoquette/'));
        return {
            title: title,
            meta: meta
        };
    }
});
